import { useCallback } from 'react';

import PortalsProvider, { PORTALS, ACTIONS, usePortalState, usePortalActions } from './PortalsProvider';

const useShowPageAccessPortal = () => {
  const pageAccessSwitcherActions = usePortalActions(PORTALS.PAGE_ACCESS_SWITCHER);
  const returnFn = useCallback(params => pageAccessSwitcherActions.show(params), [pageAccessSwitcherActions]);

  return returnFn;
};

const useShowPageAccessPortalForCasting = () => {
  const showPageAccessPortal = useShowPageAccessPortal();
  const returnFn = useCallback(
    select => showPageAccessPortal({ forCastingTool: true, select }),
    [showPageAccessPortal],
  );

  return returnFn;
};

// NOTE: Custom wrapper hooks
export { useShowPageAccessPortal, useShowPageAccessPortalForCasting };

// NOTE: Default exports
export { PORTALS, ACTIONS, usePortalState, usePortalActions };
export default PortalsProvider;
